import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getLinkedStandards = (standardId: string | number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_LINKEDSTANDARD, {
    params: {
      id: standardId,
    },
  });
};

export const addLinking = (
  userId: number,
  sourceStandard: number,
  destinationStandardId: number
) => {
  const params = {
    userId: userId,
    sourceStandardId: sourceStandard,
    destinationStandardId: destinationStandardId,
  };

  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_LINKEDSTANDARD,
    params,
    {}
  );
};

export const disableLinking = (
  userId: number,
  sourceStandard: number,
  destinationStandard: number,
  isDisable: boolean
) => {
  const params = {
    userId: userId,
    SourceStandardId: sourceStandard,
    DestinationStandardId: destinationStandard,
    isDisable: isDisable,
  };
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_LINKEDSTANDARD,
    params,
    {}
  );
};

export const deleteLinking = (
  userId: number,
  sourceStandard: number,
  destinationStandards: string
) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_LINKEDSTANDARD, {
    params: {
      userId: userId,
      sourceStandardId: sourceStandard,
      destinationStandardIds: destinationStandards,
    },
  });
};
export const getAssociatedStandards = (standardId: string | number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_LINKEDSTANDARDS, {
    params: {
      standardId: standardId,
    },
  });
};
